import _stringUtils from '@app/utils/string.utils';

const validate = (values) => {
    const errors = {};
    const { o_securitycode } = values;
    if (_stringUtils.isEmpty(o_securitycode)) {
        errors.o_securitycode = 'Mã bảo mật không được để trống!';
    }
    return errors;
};

export default validate;
